import Repository from './Repository';

const resource = '/course'

export default {
    getCourseContents ({courseId, getParams}) {
        let getUrl = `course/${courseId}`;
        getUrl = getParams === "author" ? getUrl + "?contents-author" : getUrl + "?contents" ;
        return Repository.get(getUrl);
    }
}